import React, { useState, useEffect } from 'react'
import { Box } from '@mui/material'
import reportsService from '../../../services/reports.service'
import { useGlobalStore } from '../../../store'
import { BlockingLoader, MuiButton } from '../../../components'
import { IconCsv } from '../../../assets/images/iconsV2'
import { getLogData, showCustomDevTool, removeCSVLocalStorage, toSentenceCase } from '../../../util'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import Papa from 'papaparse';
import { CONST_EXPORT_TO_CSV_NAME } from '../../../constants'

const csvIconImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAACvElEQVR4nO2X24tNURzHP+PMGJeQO5EXDzxRLuUvmAeKBykmyaMH8UDRPCjxMA/y4FakXFJeplwSD6JcojRhRpRLkRglJYpcZ2nVd9fqWGfbc2avtc/R/tZqt3/fdfl99t5r7bWgVHPJBCpPgBn/A4iJDWNUQvQZFcYEBOnTtR+YmvMYUUEmAr2x3owJCEJMGBMYJBqMiQASBcZEAgkOYyKCWAWDiQ0SDKYIkCAwRYGgn2RfXjChtyhDKf15DJqnhrPRbCiQQvIwJUi+MiWIVII0G0gF2AE8B34A9x2vFegCngJf5Y0FtqrPk07deYq9LgrktPz3wHngiOPtlWdBeoB7ii9V/IFTd41iZ4sAWe4kOt3jfwAGgNFV8Ta9oe/ASMX2qK/NdeSRSWkd9Mjb6PFsgr+AF0CLx7+htgt1f0H3i+rII5PSOngrb3YN/7r8Q86TT9Qtb4PuXwKfNa+Gmkcm1eqgRU/8pya8T/P1edn2d4CZjrdK8X3AeGAQuFpHHsMGaVXcrlQjUtrPdbbi9tqu+DQlfxlYIn83AZX2JD7J+9c5YZzeiK271onbJfsVsF5eBwWB3PIkV0udqrvLiZ3SW9mvz9R+Yr6xc9nOpzXcIu8RMMXjVzyTe50T26SYnegPU8Y2oUHalUDyQ7Tf+wl5Y/QPOafVyz75Z4onWuD0fzjj2CYEiNVk4JhAvilptELd1pJqgc54lumKM886iwYJKVOCeFSC5CBTghQIcjDjP8PUKAcaBcQuxRfrBLmSsmv+q2EM2T1ZssHs9RzIEo0C7qreY2BCI86RWcAbjWmP0T4dl/8OmNPIk30x8EXjbqvytituj8rLmmHVWg38VlmhWId2yYNVm89MMpHLgPO5dCn2EVipq73fWc+TiQ1iqibw0Sov2V03ndqAa4K46RyVm1L2qHAJmJRW6w+SrfNAG745uAAAAABJRU5ErkJggg=='

const DownloadCSV = (props) => {
  const {
    projectIdValue,
    setPPTModalActive,
    setAskIaActiveState,
    setCSVModalActive,
    setCSVSubLhs,
    setExportToCsvCount,
    exportToCsvObject,
    setExportToCsvObject,
    exportToCsvCount,
    subLhs,
    setSubLhs,
    lhs,
    currentTabId
  } = useGlobalStore()

  // If you want the sheetName to fetch from the sheet just remove all the conditions and on default state add {}
  const [sheetName, setSheetName] = useState(false);
  const [loaderDetails_show, setLoaderDetails_show] = useState(false)
  const [loaderDetails_total, setLoaderDetails_total] = useState(0)
  const [loaderDetails_count, setLoaderDetails_count] = useState(0)
  const [totalZipFiles, setTotalZipFiles] = useState([])

  useEffect(() => {
      if(sheetName) {
      fetch(CONST_EXPORT_TO_CSV_NAME)
      .then((res) => res.text())
      .then((csvText) => {
        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: function (results) {
            let sheetData = {}
            if (results.data) {
              results.data.forEach(row => {
                sheetData[row['Actual Result']] = row['Expected Result'];
              });
            }
            
            setSheetName(sheetData);
          },
        });
      }); 
    }
    }, [])

  const removeUnwantedComponentsForExportToCsvFunc = (array) => {
    const arrayNotIncludes = [
      'BusinessObjective',
      'Recommendation',
      'CustomImage',
      'Sandbox',
      'ResearchDesign',
      'CategoryPersona',
      'InsightsMiningFrameworkWithoutSentiments',
      'CampaignTriggers',
      'CampaignSegmentsEngagementOverview',
      'CampaignSegmentsEngagementProgression',
      'InsightsMiningFrameworkWithSentiments',
      'InsightsMiningFrameworkWithoutSentiments',
      'Snapshot',
    ]
    const finalArray = array.filter((f) => !arrayNotIncludes.includes(f.InsightsElementType)) // NOT INCLUDES DEFAULT ARRAY
    return finalArray
  }

  const getLhsList = async () => {
    const resp = await reportsService.reportAllTabsApi({ studyId: projectIdValue?.StudyId })
    const lhsTabsRes = resp
      .sort((a, b) => a.InsightsElementOrder - b.InsightsElementOrder)
      .filter((t) => t.InsightsElementVisible)
    let lhsTabs1 = removeUnwantedComponentsForExportToCsvFunc(lhsTabsRes).map((tab) => ({
      ...tab,
      currentTabId: currentTabId
    }))
    if(currentTabId){
      lhsTabs1 = lhsTabs1.filter(f => f.TabId === f.currentTabId.TabId)
    }
    setExportToCsvCount(lhsTabs1.length)
    setCSVSubLhs(lhsTabs1)
  }

  const exportToCsvFunc1 = () => {
    setCSVModalActive(true)
    setPPTModalActive(false)
    setAskIaActiveState('none')
    setLoaderDetails_show(true)
    getLhsList()
  }

  const exportToCsvFunc2 = () => {
    updateLoadingStatus('show')

    if (
      totalZipFiles.length === 0 &&
      loaderDetails_total > 0 &&
      loaderDetails_count >= (loaderDetails_total-1)
    ) {
      const obj = Object.keys(exportToCsvObject).filter((f) => f.indexOf('___sheet_1') === -1)
      // const splitArray = (arr, chunkSize) => {
      //   let result = []
      //   for (let i = 0; i < arr.length; i += chunkSize) {
      //     result.push(arr.slice(i, i + chunkSize))
      //   }
      //   return result
      // } 
      const groupByTabId = (arr) => {
        const groups = {};

        arr.forEach((item) => {
          const parts = item.split('____');
          const tabId = parts[parts.length - 1]; 

          if (!groups[tabId]) {
            groups[tabId] = [];
          }

          groups[tabId].push(item);
        });

        return Object.values(groups); 
      };

      setTimeout(() => {
        // const count = obj.length < 100 ? obj.length / 2 : 100
        // const objNestedArrays = splitArray(obj, count)
        const objNestedArrays = groupByTabId(obj);
        if (objNestedArrays.length > 0) setTotalZipFiles(objNestedArrays);
        // else exportToCsvFunc2()
      }, 5000)
    }
  }
  
  const convertPercentages = (dataObj) => {
    const updatedObj = {};

    for (const key in dataObj) {
      const rows = dataObj[key];
      if (!Array.isArray(rows) || rows.length < 2) {
        updatedObj[key] = rows;
        continue;
      }

      const headerIndex = rows.findIndex(
        row =>
          Array.isArray(row) &&
          row.some(cell =>
            typeof cell === 'string' &&
            /(percent(age)?|percentage|nps)/i.test(cell)
          )
      );

      if (headerIndex === -1) {
        updatedObj[key] = rows.map(row => row.map(cell => escapeCsvCell(cell)));
        continue;
      }

      const headers = rows[headerIndex];

      // indexes of percent-type headers
      const percentIndexes = headers
        .map((h, i) => (/(percent(age)?|percentage|nps)/i.test(h) ? i : -1))
        .filter(i => i !== -1);

      // Remove only those columns that have ALL empty (not 0) values below header
      const emptyCols = percentIndexes.filter(colIndex =>
        rows.slice(headerIndex + 1).every(row => {
          const val = row?.[colIndex];
          return val === '' || val === null || val === undefined;
        })
      );

      const shouldRemoveIndexes = new Set(emptyCols);

      // Clean rows & apply % conversion
      const finalRows = rows.map((row, rowIdx) => {
        return row
          .filter((_, colIdx) => !shouldRemoveIndexes.has(colIdx))
          .map((cell, colIdx) => {
            const originalColIdx = headers.findIndex((_, i) => {
              if (!shouldRemoveIndexes.has(i) && colIdx-- === 0) return true;
              return false;
            });

            const isPercentCol = percentIndexes.includes(originalColIdx);
            if (
              rowIdx > headerIndex &&
              isPercentCol &&
              typeof cell === 'number' &&
              cell >= 0 &&
              cell <= 1
            ) {
              return escapeCsvCell(`${Math.round(cell * 100)}%`);
            }

            return escapeCsvCell(cell);
          });
      });

      updatedObj[key] = finalRows;
    }

    return updatedObj;
  };

  function escapeCsvCell(cell) {
    let str = cell?.toString() ?? ''
    // Prevent Excel formula injection like - , + , = , @  it adds space before in that case.
    if (/^[=+\-@]/.test(str)) {
      str = ' ' + str
    }
    // Escape CSV special characters
    return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str
  }

  const capitalized = str => str.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('');

  // Matching the string in the sheet
  const matchSheetName = (str) => sheetName[str.replace(/\u00A0/g, ' ').trim()] ?? str;

  function decodeAndCleanTitle(rawTitle) {
    // Decode HTML entities
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = rawTitle;
    const decoded = tempDiv.textContent || tempDiv.innerText || '';

    // Remove any HTML tags
    const noTags = decoded.replace(/<[^>]*>/g, '');

    // Remove all special characters (except letters, numbers, spaces, hyphens, and underscores) and collapsing multiple spaces into one
    const clean = noTags.replace(/[^\w\s-]/g, ' ').replace(/\s+/g, ' ').trim();

    return clean;
  }

  const exportToCsvFunc3 = () => {
    if (totalZipFiles.length > 0) {
        // convert the csv data numbers into percentage 
        const transformedData = convertPercentages(exportToCsvObject);

        const logs = [['Sr', 'Component Name', 'Component Id', 'Title Name', 'Sheet Name' , 'tabName' , 'filename', 'Status']]

        const objRecussionFunc = (index) => {
          const zip = new JSZip()
          let tabName = '';
          const counters = {
            BrandImageryMappingGraph: 1,
            BrandImageryMappingAndProgressionGraph: 1,
            BrandMagnetScoreAndProgression: 1,
          };
         
          totalZipFiles[index].forEach((key, i) => {
            const keySplit = key
              .replaceAll('ampltpampgt', '')
              .replaceAll('amplt_pampgt', '')
              .split('____')
            if (transformedData[key]?.length > 1) {
              const csvContent = transformedData[key].join('\n');
              const tabEntry = lhs.find(tab => tab.TabId === keySplit[8]);
              tabName = tabEntry?.TabName || ''; 
              const parentTitle = keySplit[6];
              const title = decodeAndCleanTitle(keySplit[5]); 

              let baseName = '';
              const hasSubType = ['drivers', 'attributes', 'sub_attribute'].some(type => keySplit[4]?.includes(type));
              
              baseName = parentTitle
                ? `${tabName}_${parentTitle.replace(/[^\w\s-]/g, '')}_${title}`
                : `${tabName}_${title}`;

              // Remove colons if present
              baseName = baseName.replaceAll(":", '');

              // if the data has drivers , attributes or sub-attribute then we will add it.
              if (hasSubType) {
                const typeSuffix = keySplit[4] ? capitalized(keySplit[4]) : '';
                baseName = `${baseName}_${typeSuffix}`;
              }

              // Updating and adding the counter because the basename is same so file is getting override.
              Object.entries(counters).forEach(([type, count]) => {
                if (keySplit[1].includes(type)) {
                  baseName += count;
                  counters[type]++;
                }
              });

              // we match if the name is exist in sheet or not
              let finalStr = '';
              finalStr = sheetName ? matchSheetName(baseName) + '__' + keySplit[7] : baseName + '__' + keySplit[7];
  
              logs.push([
                logs.length + 1,
                keySplit[1],
                keySplit[2],
                toSentenceCase(keySplit[3].replaceAll('_', ' ')),
                toSentenceCase(keySplit[4].replaceAll('_', ' ')),
                tabName,
                finalStr,
                'Done',
              ])
              if (document.querySelector('#csvLoadingStatus')) {
                document.querySelector('#csvLoadingStatus ol').innerHTML +=
                  `<li>ContentLen: ${csvContent.length} | key:${keySplit[2]} | key:${finalStr}</li>`
              }
              if(showCustomDevTool('dev')){
                console.log(`Csv FIle Name : ${finalStr} And csvContent : ${csvContent}`)
              }
              zip.file(`${finalStr}.csv`, '\uFEFF' + csvContent, { delimiter: ';' });
              localStorage.removeItem(key)
            } else {
              logs.push([
                logs.length + 1,
                keySplit[1],
                keySplit[2],
                toSentenceCase(keySplit[3].replaceAll('_', ' ')),
                toSentenceCase(keySplit[4].replaceAll('_', ' ')),
                '',
                '',
                'Failed',
              ])
            }
          })
  
          zip.generateAsync({ type: 'blob' }).then((blob) => {
            const headerLogData = projectIdValue.ProjectId
              ? getLogData(
                  'GetProjects',
                  'GetProjects',
                  {},
                  { ProjectId: projectIdValue.ProjectId }
                )[0]
              : {}
  
            let zipFileName =
              `${headerLogData.BrandName || headerLogData.CategoryName}____${headerLogData.ProjectType}____${headerLogData.MarketName}____${projectIdValue.Period}____${tabName}.`
                .replaceAll(' ', '_')
                .replaceAll('-', '')
            saveAs(blob, zipFileName + 'zip')

            const resettingObjectsFunc = () => {
              const subLhsData = subLhs
              setSubLhs([])
              setTimeout(() => {
                removeCSVLocalStorage('csv___')
  
                setLoaderDetails_show(false)
                setLoaderDetails_total(0)
                setLoaderDetails_count(0)
  
                setExportToCsvCount(0)
                setCSVSubLhs([])
                setTotalZipFiles([])
  
                setCSVModalActive(false)
                setExportToCsvObject({})
  
                setLoaderDetails_show(false)
                setSubLhs(subLhsData)
                // updateLoadingStatus('hide')
              }, 1500)
            }

            // CODING IS PENDING FROM HERE FOR RECURSION OF MULTIPLE ZIP FILES
  
            // if (totalZipFiles[index + 1]) {
              // console.log('proceeding to next zip file');
              // objRecussionFunc(index + 1)

              // resettingObjectsFunc()

              // LOOPING FUNCTION FOR RECURSION AND DOWNLOADING ALL THE ZIP FILES ONE BY ONE
              // setTimeout(() => {
              //   const selected = document.querySelector('.lhsWrapper .lhsLevel1_.selected')
              //   const nextElem = selected.nextElementSibling;
              //   if (nextElem) {
              //     resettingObjectsFunc()
              //     // nextElem.querySelector('a').click();
              //     setTimeout(() => {
              //       console.log('ready for next zip file');
              //       document.querySelector('#idExportToCSV').click();
              //     }, 1000)
              //   } else {
              //     console.log('No next sibling element');
              //   }
              // }, 2000)

            // } else {
              // const zip = new JSZip()
              // zipFileName = zipFileName.split("____").slice(0, 4).join("____")
              // const csvContent = logs.join('\n')
              // zip.file(zipFileName + '__logs.csv', csvContent)
              // zip.generateAsync({ type: 'blob' }).then((blob) => {
              //   saveAs(blob, zipFileName + '__logs.zip')
              // })
  
              resettingObjectsFunc()
            // }
          })
        }

        objRecussionFunc(0)
    }
  }

  const updateLoadingStatus = (action = 'show') => {
    if (showCustomDevTool('dev')) {
      if (document.getElementById('csvLoadingStatus')) {
        if (action === 'show') {
          document.querySelector('#pptLoadingStatus').style.display = 'none'
          document.querySelector('#csvLoadingStatus').style.display = 'block'
          document.querySelector('#csvLoadingStatus #current').textContent = loaderDetails_count
          document.querySelector('#csvLoadingStatus #total').textContent = loaderDetails_total
        } else if (action === 'hide') {
          document.querySelector('#csvLoadingStatus').style.display = 'none'
          document.querySelector('#csvLoadingStatus strong').textContent = 0
          document.querySelector('#csvLoadingStatus ol').innerHTML = ''
        }
      }
    }
  }

  useEffect(() => {
    setLoaderDetails_total(exportToCsvCount)
  }, [exportToCsvCount])

  useEffect(() => {
    const countArray = Object.keys(exportToCsvObject).map(
      (d) => d.replace('csv____', '').split('____')[1]
    )
    const countValue = [...new Set(countArray)]
    setLoaderDetails_count(countValue.length)
  }, [exportToCsvObject])

  useEffect(() => {
    exportToCsvFunc2()
  }, [loaderDetails_count])

  useEffect(() => {
    exportToCsvFunc3()
  }, [totalZipFiles])

  return (
    <>
      <MuiButton
        size='small'
        // startIcon={<IconCsv />}
        color='dark'
        variant='outlined'
        label=''
        id='idExportToCSV'
        onClick={() => {
          exportToCsvFunc1()
        }}
        style={{border: '0'}}
      >
        <img src={csvIconImage} alt='Export to CSV' style={{ width: '30px', height: '30px' }} />
      </MuiButton>
      {loaderDetails_show && loaderDetails_total > 0 && (
        <BlockingLoader
          msg={
            totalZipFiles.length > 0
              ? `Preparing total ${totalZipFiles.length} zip files`
              : 'Preparing csv file'
          }
          value={loaderDetails_count}
          maxValue={loaderDetails_total}
        />
      )}
      {/* {loaderDetails_show && loaderDetails_total>0 && loaderDetails_total>loaderDetails_count && <BlockingLoader msg={'Preparing csv file'} value={loaderDetails_count} maxValue={loaderDetails_total} />}
            {loaderDetails_show && loaderDetails_total>0 && loaderDetails_total===loaderDetails_count && <BlockingLoader msg={'Compressing all csv files to zip file'} value={loaderDetails_count} maxValue={loaderDetails_total} />} */}
    </>
  )
}

export default DownloadCSV
